/**
 * Full-page loading spinner shown while lazy pages load.
 */
function PageLoader() {
    return (
        <div
            className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-white"
            role="status"
            aria-label="Loading page"
        >
            <div className="relative w-16 h-16">
                <div className="absolute inset-0 rounded-full border-4 border-neutral-100" />
                <div className="absolute inset-0 rounded-full border-4 border-t-primary-600 border-r-transparent border-b-transparent border-l-transparent animate-spin" />
            </div>
            <p className="mt-4 text-sm text-neutral-500 font-medium">Loading…</p>
        </div>
    );
}

export default PageLoader;
